// src/components/dashboard/vendor/MonthlySessionsChart.js
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import DashboardCard from '../DashboardCard';

function MonthlySessionsChart({ data, loading }) {
  return (
    <DashboardCard
      title="Monthly Sessions Delivered"
      icon="bi-graph-up"
      loading={loading}
      isEmpty={!loading && data.length === 0}
      emptyMessage="No sessions delivered yet."
    >
      <div style={{ width: '100%', height: 260 }}>
        <ResponsiveContainer>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Line type="monotone" dataKey="sessions" stroke="#0d6efd" strokeWidth={2} name="Sessions" />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </DashboardCard>
  );
}

export default MonthlySessionsChart;
